import LoadingAnimation from "../assets/Loading.json";
import Lottie from "lottie-react";

const Loading = () => {
  return (
    <div className="mt-10 text-4xl h-96 font-rob flex items-center justify-center">
      <Lottie animationData={LoadingAnimation} />
    </div>
  );
};

export default Loading;
